module.exports = __webpack_public_path__ + "img/france-respiratory-diseases-female.8b34fee6.png";